import { useMemo, type FC } from "react"

import type { SpanPlotDef } from "types/dashboard.types"

import { useSpanPlotView } from "helpers/hooks/plots/useSpanPlotView"
import SpanTelemetryPlot from "./SpanTelemetryPlot"

interface SpanPlotProps {
  def: SpanPlotDef
  spanIds: number[]
}

const SpanPlot: FC<SpanPlotProps> = ({ def, spanIds }) => {
  // The limits are one span's own values, so a plot of several draws none.
  const { view } = useSpanPlotView(def, spanIds.length === 1 ? spanIds[0] : undefined)
  const formattedDef = useMemo(() => ({ ...def, view }), [def, view])
  return <SpanTelemetryPlot def={formattedDef} spanIds={spanIds} />
}

export default SpanPlot
